if (!customElements.get('zenify-trust-bar')) {
  customElements.define('zenify-trust-bar', class extends HTMLElement {
    connectedCallback() {
      if (!this.onTrustKeydown) {
        this.dataset.focusModality = 'pointer';
        this.addEventListener('pointerdown', () => { this.dataset.focusModality = 'pointer'; }, true);
        this.onTrustKeydown = event => {
          if (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ' || event.key === 'Escape' || event.key.startsWith('Arrow')) {
            this.dataset.focusModality = 'keyboard';
          }
        };
      }
      document.addEventListener('keydown', this.onTrustKeydown, true);
      if (this.initialized) return;
      this.initialized = true;
      this.dialogs = Array.from(this.querySelectorAll('[data-trust-dialog]'));
      this.querySelectorAll('[data-trust-open]').forEach(button => {
        button.addEventListener('click', () => {
          const dialog = this.dialogs.find(item => item.dataset.trustDialog === button.dataset.trustOpen);
          if (!dialog) return;
          this.syncReviews();
          this.opener = button;
          this.dialogs.forEach(item => { if (item.open) item.close(); });
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          dialog.showModal();
          dialog.querySelector('[data-trust-close]').focus({ preventScroll: true });
        });
      });
      this.dialogs.forEach(dialog => {
        dialog.querySelector('[data-trust-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.opener?.focus({ preventScroll: true });
        });
      });
      if (!this.syncReviews()) {
        this.observer = new MutationObserver(() => { if (this.syncReviews()) this.observer.disconnect(); });
        this.observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
        this.timeout = setTimeout(() => this.observer?.disconnect(), 30000);
      }
    }
    syncReviews() {
      const sourceCount = document.querySelector('.jdgm-medals-wrapper .jdgm-rating__count');
      const count = Number(sourceCount?.dataset.value);
      if (Number.isFinite(count) && count > 0) {
        const label = this.dataset.reviewLabel.replace('__count__', new Intl.NumberFormat(document.documentElement.lang || 'en').format(count));
        this.querySelectorAll('[data-trust-count]').forEach(element => { if (element.textContent !== label) element.textContent = label; });
      }
      const target = this.querySelector('[data-trust-stories]');
      const cards = Array.from(document.querySelectorAll('.jdgm-cards-carousel .jdgm-card[data-review-id]:not([data-clone-type])'));
      if (!target.children.length) {
        cards.slice(0, 3).forEach(card => {
          const body = card.querySelector('.jdgm-text p')?.textContent.trim();
          const author = card.querySelector('.jdgm-reviewer-name')?.textContent.trim();
          if (!body || !author) return;
          const figure = document.createElement('figure');
          const quote = document.createElement('blockquote');
          const caption = document.createElement('figcaption');
          quote.textContent = body;
          caption.textContent = author;
          figure.append(quote, caption);
          target.append(figure);
        });
      }
      this.querySelector('[data-trust-loading]').hidden = target.children.length > 0;
      return count > 0 && target.children.length > 0;
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this.onTrustKeydown, true);
      this.observer?.disconnect();
      clearTimeout(this.timeout);
      this.dialogs?.forEach(dialog => { if (dialog.open) dialog.close(); });
    }
  });
}
